export const CANONICAL_URL = 'https://touchstone.guide';
export const SITE_NAME = 'Touchstone';
export const ORGANIZATION_ID = `${CANONICAL_URL}#organization`;
export const WEBSITE_ID = `${CANONICAL_URL}#website`;
export const DEFAULT_AUTHOR_KEY = 'quinn';

export const CATEGORY_PHRASE = 'AI tool discovery and workflow planning platform';

export const TOUCHSTONE_POSITIONING = {
  mission:
    'Touchstone maps the AI tool landscape and builds personalized workflows.',
  summary:
    'Touchstone is an AI tool discovery and workflow planning platform with a neutral research layer for tool documentation, comparisons, and workflow planning.',
  neutrality:
    'Touchstone does not sell rankings, accept paid placements, or use affiliate links.',
  workflow:
    'Users can explore tools visually, compare fit based on context, and assemble tools into working pipelines.',
};

export const HOMEPAGE_ROUTE = '/home';
export const EXPLORER_ROUTE = '/';
